import {
  map,
  throttleTime,
  filter,
  distinctUntilChanged,
  tap
} from "rxjs/operators";
import { combineLatest, fromEvent, interval, merge } from "rxjs";
import store, { mutateState } from "../store";
import { MAXSectionCount } from "@/constant";
import touchsubject from "./touch";
import buildHash from "@/utils/buildHash";

export const sceneStream = store.obs.pipe(map(v => v.scene));

export const slideStream = store.obs.pipe(map(v => v.slide));

combineLatest([sceneStream, slideStream])
  .pipe(
    distinctUntilChanged((a, b) => a[0] + a[1] === b[0] + b[1]),
    tap(v => console.info("scene changed", v)),
    map(v => v)
  )
  .subscribe(([scene, slide]) => {
    const hash = buildHash(scene, slide);
    setTimeout(() => {
      history.pushState({}, "", hash);
    }, 50);
  });

export const AnimationLockStream = store.obs.pipe(
  map(v => v.animationlock),
  distinctUntilChanged()
);

// resize 事件 / 页面缩放 的数据流
export const pageZoomStream = merge(
  fromEvent(window, "resize"),
  interval(200).pipe(
    map(() => window.devicePixelRatio),
    distinctUntilChanged()
  )
);

// 滚动事件的数据流（当前业务场景下不存在
export const scrollStream = fromEvent<WheelEvent>(document, "scroll", {
  passive: true
}).pipe(
  throttleTime(200),
  map(v => v.deltaY > 0),
  tap(v => console.info("scrollStream", v))
);

// 滚轮事件的数据流
export const wheelStream = fromEvent<WheelEvent>(document, "wheel", {
  passive: true
}).pipe(
  // mac 上触摸屏的滑动持续事件接近1500ms
  throttleTime(1500),
  filter(e => {
    const paths = e.composedPath();
    const result = paths.reduce<boolean>((iter, now) => {
      const bailout =
        (now as HTMLElement).className?.indexOf("side-menu-drawer") > -1;
      if (bailout) {
        return false;
      }
      return iter;
    }, true);
    return result;
  }),
  map(v => v.deltaY > 0),
  tap(v => console.info("wheelstream", v))
);

// 屏幕触摸时间的数据流
export const touchstream = touchsubject.pipe(
  filter(v => [1, 2].includes(v)),
  map(v => v === 1),
  throttleTime(300),
  tap(v => console.info("touchstream", v))
);

// 屏幕滑动的数据流
export const sceneChangeStream = combineLatest([
  merge(wheelStream, scrollStream, touchstream)
]).pipe(
  throttleTime(300),
  map(([flag]) => {
    const scene = store.getValue().scene;
    const wrap = document.querySelector(`.scene${scene}`);
    const nextScene = Math.min(
      Math.max(0, flag ? scene + 1 : scene - 1),
      MAXSectionCount - 1
    );
    if (nextScene < scene) {
      return (wrap?.scrollTop || 0) > 0 ? scene : nextScene;
    }
    if (nextScene > scene) {
      const scrollTop = (wrap?.scrollTop || 0) + window.innerHeight;
      const contentHeight = wrap?.scrollHeight || 0;
      return scrollTop >= contentHeight ? nextScene : scene;
    }
    return scene;
  }),
  distinctUntilChanged()
);

// history 变化的事件流
export const historyPopStateStream = fromEvent(window, "popstate").pipe(
  map(() => location.hash),
  // distinctUntilChanged(),
  tap(() => {
    mutateState(state => {
      const str = location.hash.replace("#", "");
      const [scenestr = "", slidestr = ""] = str.split("-");
      state.scene = +scenestr.replace("scene", "") || 0;
      state.slide = +slidestr.replace("slide", "") || 0;
    });
  })
);
